import ItemsEnriquecidos from './itemsenriquecidos.vue';
import ItemEnriquecidoForm from './itemenriquecido-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/itemsenriquecidos/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemsenriquecidos', ['ADMIN', 'DTYCAL'], ItemsEnriquecidos)
    },
    {
        path: '/itemsenriquecidos/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemsenriquecidos/new', ['ADMIN', 'DTYCAL'], ItemEnriquecidoForm)
    },
    {
        path: '/itemsenriquecidos/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemsenriquecidos/edit', ['ADMIN', 'DTYCAL'], ItemEnriquecidoForm)
    },
    {
        path: '/itemsenriquecidos/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemsenriquecidos/view', ['ADMIN', 'DTYCAL'], ItemEnriquecidoForm, { editable: false })
    },
];
export default routes;
